export default "__VITE_ASSET__d00cf13a__$_?component__"